"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const styles_1 = require("@mui/styles");
exports.useStyles = (0, styles_1.makeStyles)(() => ({
    container: {
        minWidth: "200px",
        position: "absolute",
        zIndex: 10,
    },
    item: {
        cursor: "pointer",
    },
}), { name: "Autocomplete" });
//# sourceMappingURL=styles.js.map